{
  "applicationPaths": {
    "appClientUrl": "https://wazari-afiprod-client.azurewebsites.net/",
    "appBrokerUrl": "https://wazari-afiprod-courtier.azurewebsites.net/",
    "appTunnelUrl": "https://wazari-afiprod-tunnel.azurewebsites.net/",
    "appZenithUrl": "https://wazari-afiprod-zenith.azurewebsites.net/",
    "appGestionUrl": "https://wazari-afiprod-gestion.azurewebsites.net/",
    "appWazariUrl": "https://wazari-afiprod-wazari.azurewebsites.net/",
    "appAfiUrl": "https://wazari-afiprod-client.azurewebsites.net/"
  },
  "toasterConfig": {
    "tapToDismiss": true,
    "timeoutMs": 5000,
    "limit": 10,
    "preventDuplicates": false,
    "showCloseButton": false,
    "newestOnTop": true,
    "animation": "flyRight"
  },
  "apiRootUrl": "https://wazari-afiprod-webapi.azurewebsites.net/api/v1",
  "logging": {
    "defaultLogger": true,
    "loggers": [
      "Auth"
    ]
  },
  "appInsights": {
    "brokerKey": "03ebd839-b835-4aee-8d36-5bd210c8df01",
    "backOfficeKey": "8ee28d07-ed26-4cc1-be47-55120202e5d2",
    "clientKey": "d24649b4-f19a-4f78-96fd-c3bd8ad1aacc"
  },
  "googleMapsApiKey": "AIzaSyCFCn9l4dtmWavgtGUmHqXdV--WImp9AVU",
  "brokerApp": {
    "support": {
      "svaNumber": "01 71 252 252",
      "email": "courtier-local@wazari.fr"
    },
    "supportTeams": [
      {
        "type": "Animation",
        "products": [
          "health",
          "car",
          "rop"
        ],
        "contacts": [
          {
            "name": "Hotline Courtier",
            "address1": "8/10 rue de la Ferme",
            "address2": "92100 BOULOGNE-BILLANCOURT",
            "phone": "01 71 252 252",
            "email": [
              "courtier@wazari.fr"
            ]
          },
          {
            "name": "Zana KADI",
            "title": "Responsable Gestion Commerciale Auto",
            "phone": "07 52 86 97 26",
            "email": [
              "zana.kadi@wazari.fr"
            ]
          },
          {
            "name": "Nela RIBEIRO",
            "title": "Responsable Gestion Commerciale Santé",
            "phone": "06 70 47 43 60",
            "email": [
              "nela.ribeiro@wazari.fr"
            ]
          },
          {
            "name": "Hugo COULON",
            "title": "Responsable  Courtage Secteur Est",
            "phone": " 06 45 10 99 70",
            "email": [
              "hugo.coulon@wazari.fr"
            ]
          },
          {
            "name": "Mathieu MASSIE",
            "title": "Responsable  Courtage Secteur Ouest",
            "phone": "06 95 07 75 69",
            "email": [
              "mathieu.massie@wazari.fr"
            ]
          }
        ]
      },
      {
        "type": "Gestion",
        "products": [
          "health"
        ],
        "contacts": [
          {
            "name": "Gestion Santé",
            "address1": "12 rue du Bois Guillaume, 91055",
            "address2": "EVRY CEDEX",
            "phone": "01 75 90 99 00",
            "email": [
              "gestionsante@wazari.fr"
            ]
          },
          {
            "name": "Guillaume MASSAGLI",
            "title": " Responsable du centre de Gestion",
            "phone": "01 75 90 99 00",
            "email": [
              "guillaume.massagli@wazari.fr"
            ]
          }
        ]
      },
      {
        "type": "Prestations",
        "products": [
          "health"
        ],
        "contacts": [
          {
            "name": "Prestations Wazari",
            "address1": "14 rue Juliot Curie CS 30248",
            "address2": "51010 CHÂLONS-EN-CHAMPAGNE CEDEX",
            "phone": "03 26 26 64 74",
            "email": [
              "prestationswazari@sgsante.fr"
            ]
          }
        ]
      },
      {
        "type": "Prestations Eco+",
        "products": [
          "health"
        ],
        "contacts": [
          {
            "name": "Gestion WAZARI",
            "address1": "TSA 50511",
            "address2": "75427 PARIS CEDEX 09",
            "phone": "01 76 24 42 93",
            "email": [
              "wazari@cpms.fr"
            ]
          }
        ]
      },
      {
        "type": "Service Informatique",
        "products": [
          "health",
          "car",
          "rop"
        ],
        "contacts": [
          {
            "name": "Équipes IT",
            "email": [
              "it@wazari.fr"
            ]
          }
        ]
      }
    ],
    "avenant": {
      "phone": "01 75 90 99 00",
      "phoneInfo": "du lundi au vendredi de 9h à 17h",
      "email": "gestionsante@wazari.fr"
    },
    "termination": {
      "phone": "01 75 90 99 00",
      "phoneInfo": "du lundi au vendredi de 9h à 17h",
      "email": "gestionsante@wazari.fr"
    },
    "quantieme": {
      "phone": "01 75 90 99 00",
      "phoneInfo": "du lundi au vendredi de 9h à 17h",
      "email": "gestionsante@wazari.fr"
    },
    "refundInfo": {
      "phone": "03 26 26 64 74",
      "phoneInfo": "du lundi au vendredi de 9h à 17h",
      "email": "prestationswazari@sgsante.fr"
    },
    "rop": {
      "effectDatesRange": 3
    }
  },
  "backofficeApp": {
    "smalltoxUrl": "https://wazari.smalltox.testenv1.me/"
  }
}